// Function that takes an array of pathStrings and returns 1 when it is the current pathname
export const isMenuActive = (pathArr) =>
  pathArr.includes(window.location.pathname) ? 1 : 0;
